import api from "../api";

const guardianQueryService = {
  // Get all guardian queries
  getQueries: async () => {
    try {
      const response = await api.get("/guardian-queries");
      return response.data;
    } catch (error) {
      console.error("Error fetching guardian queries:", error);
      throw new Error(
        error.response?.data?.message || "Failed to fetch queries"
      );
    }
  },

  // Get a specific guardian query by ID
  getQuery: async (id) => {
    try {
      const response = await api.get(`/guardian-queries/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching guardian query:", error);
      throw new Error(error.response?.data?.message || "Failed to fetch query");
    }
  },

  // Create a new guardian query
  createQuery: async (queryData) => {
    try {
      const response = await api.post("/guardian-queries", queryData);
      return response.data;
    } catch (error) {
      console.error("Error creating guardian query:", error);
      throw new Error(
        error.response?.data?.message || "Failed to create query"
      );
    }
  },

  // Reply to a guardian query
  replyToQuery: async (id, replyData) => {
    try {
      // Only send description - backend will determine user info and is_gg based on auth
      const payload = {
        description: replyData.description,
      };
      const response = await api.post(`/guardian-queries/${id}/reply`, payload);
      return response.data;
    } catch (error) {
      console.error("Error replying to guardian query:", error);
      throw new Error(
        error.response?.data?.message || "Failed to submit reply"
      );
    }
  },

  // Close a guardian query
  closeQuery: async (id) => {
    try {
      const response = await api.post(`/guardian-queries/${id}/close`);
      return response.data;
    } catch (error) {
      console.error("Error closing guardian query:", error);
      throw new Error(error.response?.data?.message || "Failed to close query");
    }
  },
};

export default guardianQueryService;
